import { __assign, __extends, __makeTemplateObject, __rest } from "tslib";
import React, { Component, createRef } from 'react';
import styled, { css } from 'styled-components';
import { noop } from 'lodash';
import { Icon } from '../Icon';
import { Flex } from '../Flex';
import { createComponent } from '../utils';
import { Field } from './Field';
import { FormError } from './FormError';
import Label from './Label';
import { createEasyInput } from './EasyInput';
var SelectContainer = createComponent({
    name: 'SelectContainer',
    as: Flex,
    style: function (_a) {
        var theme = _a.theme;
        return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    background: white;\n    border: 1px solid ", ";\n    height: 48px;\n    outline: none;\n    width: 100%;\n    position: relative;\n    border-radius: ", "px;\n    transition: 250ms all;\n    -webkit-appearance: none;\n    font-family: inherit;\n    font-size: ", "px;\n    vertical-align: middle;\n  "], ["\n    background: white;\n    border: 1px solid ", ";\n    height: 48px;\n    outline: none;\n    width: 100%;\n    position: relative;\n    border-radius: ", "px;\n    transition: 250ms all;\n    -webkit-appearance: none;\n    font-family: inherit;\n    font-size: ", "px;\n    vertical-align: middle;\n  "])), theme.colors.greyLight, theme.radius, theme.typography.fontSize);
    },
});
var IconContainer = styled(Flex)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  position: absolute;\n  height: 100%;\n  right: 0;\n  top: 0;\n  z-index: 1;\n"], ["\n  position: absolute;\n  height: 100%;\n  right: 0;\n  top: 0;\n  z-index: 1;\n"])));
var SelectInput = createComponent({
    name: 'Select',
    tag: 'select',
    style: function (_a) {
        var theme = _a.theme, value = _a.value, isFloating = _a.isFloating;
        return css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    position: relative;\n    z-index: 2;\n    padding: 0 32px 0px 8px;\n    outline: none;\n    width: 100%;\n    font-size: ", "px;\n    font-family: inherit;\n    background: transparent;\n    color: ", ";\n    border: none;\n    -webkit-appearance: none;\n\n    ::-ms-expand {\n      display: none;\n    }\n    ::-ms-value\u00A0 {\n      background: none;\n      color: ", ";\n    }\n\n    ", ";\n  "], ["\n    position: relative;\n    z-index: 2;\n    padding: 0 32px 0px 8px;\n    outline: none;\n    width: 100%;\n    font-size: ", "px;\n    font-family: inherit;\n    background: transparent;\n    color: ", ";\n    border: none;\n    -webkit-appearance: none;\n\n    ::-ms-expand {\n      display: none;\n    }\n    ::-ms-value\u00A0 {\n      background: none;\n      color: ", ";\n    }\n\n    ",
            ";\n  "])), theme.typography.fontSize, value ? theme.typography.color : theme.colors.greyDarker, value ? theme.typography.color : theme.colors.greyDarker, isFloating && css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n      margin-top: 16px;\n    "], ["\n      margin-top: 16px;\n    "]))));
    },
});
var SelectOption = createComponent({
    name: 'SelectOption',
    tag: 'option',
});
var Select = (function (_super) {
    __extends(Select, _super);
    function Select() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            value: '',
        };
        _this.innerRef = createRef();
        _this.handleChange = function (e) {
            _this.setState({ value: e.target.value });
            _this.props.onChange(e.target.name, e.target.value);
        };
        _this.handleBlur = function (e) {
            _this.props.onBlur(e.target.name);
        };
        return _this;
    }
    Select.getDerivedStateFromProps = function (props, state) {
        if (props.value !== undefined && props.value !== state.value) {
            return {
                value: props.value,
            };
        }
        return null;
    };
    Object.defineProperty(Select.prototype, "ref", {
        get: function () {
            return this.props.forwardedRef || this.innerRef;
        },
        enumerable: false,
        configurable: true
    });
    Select.prototype.render = function () {
        var _a = this.props, id = _a.id, name = _a.name, options = _a.options, placeholder = _a.placeholder, error = _a.error, _b = _a.size, size = _b === void 0 ? 'md' : _b, label = _a.label, floating = _a.floating, props = __rest(_a, ["id", "name", "options", "placeholder", "error", "size", "label", "floating"]);
        var value = this.state.value;
        var isFloating = floating && value !== undefined && ("" + value).trim();
        var FloatingLabel = (React.createElement(Label, { htmlFor: id, size: size, isFloating: !!isFloating, isFloatable: floating }, label));
        return (React.createElement(Field, null,
            label && !floating && React.createElement(Label, { size: size }, label),
            React.createElement(SelectContainer, { value: value, size: size },
                label && isFloating && FloatingLabel,
                React.createElement(SelectInput, __assign({}, props, { size: size, ref: this.ref, name: name, value: value, onChange: this.handleChange, isFloating: isFloating, onBlur: this.handleBlur }),
                    React.createElement(SelectOption, { value: "" }, placeholder || 'Select an option...'),
                    options.map(function (option) { return (React.createElement(SelectOption, { key: option.value, value: option.value }, option.label)); })),
                React.createElement(IconContainer, { "aria-hidden": "true", mr: 2, alignItems: "center", justifyContent: "center" },
                    React.createElement(Icon, { name: "chevron-down", color: "greyDarker", size: 24 }))),
            error && React.createElement(FormError, null, error)));
    };
    Select.defaultProps = {
        onChange: noop,
        onBlur: noop,
    };
    return Select;
}(Component));
export { Select };
export default createEasyInput(Select);
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
//# sourceMappingURL=Select.js.map